var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_8096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 12.5C23 18.5751 18.0751 23.5 12 23.5C5.92487 23.5 1 18.5751 1 12.5C1 6.42487 5.92487 1.5 12 1.5C18.0751 1.5 23 6.42487 23 12.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96657 18.5L17.7958 6.5H16.1794L5.35017 18.5H6.96657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1206_8096",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4732 18.5L5.40002 6.5H9.16103L18.2342 18.5H14.4732Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4732 18.5L5.40002 6.5H9.16103L18.2342 18.5H14.4732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40002 6.5V5.5H3.39026L4.60237 7.10311L5.40002 6.5ZM14.4732 18.5L13.6755 19.1031L13.9756 19.5H14.4732V18.5ZM9.16103 6.5L9.95869 5.89689L9.6586 5.5H9.16103V6.5ZM18.2342 18.5V19.5H20.244L19.0319 17.8969L18.2342 18.5ZM4.60237 7.10311L13.6755 19.1031L15.2709 17.8969L6.19768 5.89689L4.60237 7.10311ZM9.16103 5.5H5.40002V7.5H9.16103V5.5ZM19.0319 17.8969L9.95869 5.89689L8.36337 7.10311L17.4365 19.1031L19.0319 17.8969ZM14.4732 19.5H18.2342V17.5H14.4732V19.5Z",
    fill: "black",
    mask: "url(#path-3-inside-1_1206_8096)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_8096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/x-twitter.3506b7b6febd6a5b5dbd0d1a9f8e7ffe.svg";
export { ForwardRef as ReactComponent };